import { render } from "./TicketNotification.vue?vue&type=template&id=37c59db2"
import script from "./TicketNotification.vue?vue&type=script&lang=js"
export * from "./TicketNotification.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__